import { LoadableAfterPaint } from '@confluence/loadable';

export const AgenticEditorBannerLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AgenticEditorBanner" */ './AgenticEditorBanner.tsx'
			)
		).AgenticEditorBanner,
});
